/**
 * Числа, деньги и доли по языку интерфейса кабинета (супер-ревью кабинета
 * 7): «1 234,50 $» и «12,3 %» на русском, «$1,234.50» и «12.3%» на
 * английском. Один Intl.NumberFormat на язык и вид: создание форматтера не
 * бесплатно, а таблицы зовут его на каждую ячейку.
 */
const formats = new Map<string, Intl.NumberFormat>();

const formatter = (
  locale: string,
  key: string,
  options: Intl.NumberFormatOptions
): Intl.NumberFormat => {
  const cacheKey = `${locale}|${key}`;
  let format = formats.get(cacheKey);
  if (!format) {
    format = new Intl.NumberFormat(locale, options);
    formats.set(cacheKey, format);
  }
  return format;
};

/** Целое или дробное число с разделителем тысяч: «12 345». */
export const formatNumber = (value: number, locale: string): string =>
  formatter(locale, "number", {}).format(value);

/** Сумма с двумя знаками и символом валюты по правилам языка. */
export const formatMoney = (
  value: number,
  currency: string,
  locale: string
): string =>
  formatter(locale, `money:${currency}`, {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);

/** Доля в процентах (12.3 значит 12,3 %), не больше одного знака. */
export const formatPercentValue = (percent: number, locale: string): string =>
  formatter(locale, "percent", {
    style: "percent",
    maximumFractionDigits: 1,
  }).format(percent / 100);
